<!-- 个人中心-修改密码 -->
<template>
  <div class="personal-center">
    <div class="my-breadcrumb">
      <span>管理员</span>
      <span>/</span>
      <span>修改密码</span>
    </div>
    <div class="personal-center-body">
      <div class="personal-center-body-title">修改密码</div>
      <div style="width: 500px">
        <el-form label-width="120px" :rules="rules" ref="form" :model="form">
          <el-row>
            <el-col :span="24">
              <el-form-item label="用户名" prop="username">
                <el-input
                  v-model.trim="user.name"
                  :maxlength="20"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="原密码" prop="past" :error="msg">
                <el-input
                  type="password"
                  v-model.trim="form.past"
                  :maxlength="20"
                  placeholder="请输入原密码"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="新密码" prop="new">
                <el-input
                  type="password"
                  v-model.trim="form.new"
                  :maxlength="20"
                  placeholder="请输入新密码"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="确认新密码" prop="confirm">
                <el-input
                  type="password"
                  v-model.trim="form.confirm"
                  :maxlength="20"
                  placeholder="请确认新密码"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button
          style="margin-left: 120px"
          size="small"
          type="primary"
          :disabled="submitting"
          @click="submitForm('form')"
          >确 定</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
// import _ from 'lodash'
import md5 from 'js-md5'
import { mapState } from 'vuex'
export default {
  name: 'PersonalCenter',
  data: function() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (/^[A-Za-z0-9]+$/.test(value) === false) {
          callback(new Error('密码仅支持包含英文字母和数字'))
        } else {
          callback()
        }
        if (this.form.confirm !== '') {
          this.$refs.form.validateField('confirm')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认新密码'))
      } else if (value !== this.form.new) {
        callback(new Error('两次输入密码不一致，请重新输入'))
      } else if (/^[A-Za-z0-9]+$/.test(value) === false) {
        callback(new Error('密码仅支持包含英文字母和数字'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        username: [],
        past: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { min: 6, message: '长度至少 6 个字符', trigger: 'blur' },
          { max: 20, message: '长度最多 20 个字符', trigger: 'blur' }
        ],
        new: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' },
          {
            min: 8,
            max: 20,
            message: '“请输入长度至少为8位的密码',
            trigger: 'blur'
          }
        ],
        confirm: [
          { required: true, message: '新密码不得为空', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' },
          {
            min: 8,
            max: 20,
            message: '“请输入长度至少为8位的密码',
            trigger: 'blur'
          }
        ]
      },
      submitting: false,
      msg: '',
      form: { username: '', past: '', new: '', confirm: '' }
    }
  },
  methods: {
    changePwd() {
      let realFormData = {
        oldPassword: md5(this.form.past + 'p@w123!@#'),
        newPassword: md5(this.form.new + 'p@w123!@#')
      }
      this.$xhrPut(`/acc/password`, realFormData).then(rs => {
        if (!rs) {
          this.submitting = false
        }
        if (rs.code === 'SUCCESS') {
          this.$message.success('密码修改成功，请重新登录')
          setTimeout(() => {
            this.$router.replace({ name: 'Login' })
          }, 500)
        } else {
          this.submitting = false
          if (rs.code === 'wrong_password') {
            this.msg = '原密码输入错误，请重新输入'
          } else if (rs.code === 'equal_password') {
            this.msg = '新密码不能与旧密码相同'
          }
        }
      })
    },

    submitForm(formName) {
      this.submitting = true
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.changePwd()
        } else {
          this.$message.error('请检查输入')
          this.submitting = false
          return false
        }
      })
    }
  },
  computed: {
    ...mapState(['user'])
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.personal-center {
  height: 100%;
  min-width: 575px;
  width: 100%;
  float: right;
  box-sizing: border-box;
  box-shadow: 0px 1px 4px 0px inset rgba(0, 0, 0, 0.12);
  overflow: hidden;
  position: relative;
  background: var(--theme-background);
  .my-breadcrumb {
    height: 48px;
    width: 100%;
    display: flex;
    align-items: center;
    padding-left: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #757575;
    background: #fff;
    margin-top: 1px;
    span:nth-of-type(1),
    span:nth-of-type(3) {
      cursor: pointer;
    }
    span:nth-of-type(2) {
      margin: 0 5px;
    }
  }
  &-body {
    width: calc(100% - 40px);
    background: #ffffff;
    border-radius: 4px;
    margin: 20px;
    padding: 20px;
    box-sizing: border-box;
    &-title {
      font-size: 16px;
      font-weight: 500;
      color: #444444;
      margin-bottom: 20px;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      &:hover {
        border-color: #409eff;
      }
    }
    .avatar {
      width: 178px;
      height: 178px;
    }
  }
  .upload-tips {
    font-size: 14px;
    font-weight: 400;
    color: #9b9b9b;
  }
}
.select {
  position: absolute;
  top: 0;
  background: #000;
  opacity: 0.6;
  line-height: 140px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/change-password/Index.vue